import { useEffect, useState } from 'react';
import { continueRender, delayRender, staticFile, useRemotionEnvironment } from 'remotion';

export const WATERMARK_FONT_FAMILY = 'AutoclipperWatermarkSora';

let fontPromise: Promise<void> | null = null;

function loadWatermarkFont(): Promise<void> {
  if (!fontPromise) {
    const face = new FontFace(WATERMARK_FONT_FAMILY, `url(${staticFile('fonts/sora-v1.ttf')})`, {
      weight: '100 800',
    });
    fontPromise = face
      .load()
      .then((loaded) => {
        document.fonts.add(loaded);
      })
      .catch((err) => {
        // Never hang a render on the font: fall back to sans-serif.
        console.warn('[watermark] font failed to load', err);
      });
  }
  return fontPromise;
}

/** Holds the render until the watermark font is ready (or failed). */
export function useWatermarkFont(): void {
  const env = useRemotionEnvironment();
  const [handle] = useState(() => (env.isClientSideRendering ? null : delayRender('Loading watermark font')));
  useEffect(() => {
    if (handle === null) return;
    void loadWatermarkFont().finally(() => continueRender(handle));
  }, [handle]);
}
